import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute: React.FC = () => {
  const { user } = useAuth();
  return user && !user.is_anonymous ? <Navigate to="/dashboard" replace /> : <Outlet />;
};

export default PublicRoute;
